
import store from '@/store/index';

export default function handlerError(params) {
    if(params.errors) {
        params.errors.forEach(error => {
            store.dispatch('/common/snackBar', { color: 'error', message: error });
            // store.dispatch()
            // this.setSnackBars({ color: 'error', message: error });
        });
    } else {
        store.dispatch('common/snackBar', { color: 'error', message: params.message });
    }   
}